import { render, staticRenderFns } from "./LiveOrderTab.vue?vue&type=template&id=4afc3d1d&scoped=true"
import script from "./LiveOrderTab.vue?vue&type=script&lang=js"
export * from "./LiveOrderTab.vue?vue&type=script&lang=js"
import style0 from "./LiveOrderTab.vue?vue&type=style&index=0&id=4afc3d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc3d1d",
  null
  
)

export default component.exports